import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f96b6b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Drag and drop files to here to upload.", -1))

export interface propsComponent {
  isPreview: boolean;
}
import { useAttrs, withDefaults, computed } from "vue";

import { defineComponent, ref } from "vue";
import FileUpload from "primevue/fileupload";
const __default__ = defineComponent({
  name: "VZAttachements",
  inheritAttrs: false,
  components: {
    FileUpload,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isPreview: boolean }


const attrs = useAttrs();
const style = computed(() => {
  return !props.isPreview ? "pointer-events: none" : "";
});
const dynamicAttrs = computed(() => {
  const clonedAttrs = { ...attrs };
  // Check if attrs.style.defaultFonts is "true !important"
  if (
    clonedAttrs.style &&
    clonedAttrs.style.defaultBorder === "true !important"
  ) {
    clonedAttrs.style.borderColor = "";
    clonedAttrs.style.borderWidth = "";
    clonedAttrs.style.borderStyle = "";
    clonedAttrs.style.padding = "";
    clonedAttrs.style.margin = "";
    clonedAttrs.borderColor = "";
    clonedAttrs.borderWidth = "";
    clonedAttrs.borderStyle = "";
    clonedAttrs.padding = "";
    clonedAttrs.margin = "";
  }

  return clonedAttrs;
});
const onUpload = () => {
  //TODO
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "VZ_TABLE_INPUT" }, _unref(dynamicAttrs)), [
    _createVNode(_unref(FileUpload), {
      name: "attachments[]",
      url: "./upload",
      onUpload: onUpload,
      multiple: true,
      accept: "image/*",
      maxFileSize: 1000000,
      style: _normalizeStyle(_unref(style))
    }, {
      empty: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["style"])
  ], 16))
}
}

})